import React from 'react';
import { Box, Typography, Container } from '@mui/material';
import { motion } from 'framer-motion';
import teamInnovation from '../../assets/support/team-innovation.webp';
import telegramLogo from '../../assets/support/telegram-logo.webp';
import whatsappLogo from '../../assets/support/whatsapp-logo.webp';

const SupportSection: React.FC = () => {
  return (
    <Box component="section" id="about" sx={{ py: { xs: 8, md: 12 }, backgroundColor: '#FFFFFF', overflow: 'hidden', width: '100%' }}>
      <Container maxWidth="xl" sx={{ width: '90%', mx: 'auto' }}>
        <Box sx={{ display: 'flex', gap: 8, alignItems: 'flex-start', flexDirection: { xs: 'column', md: 'row' } }}>
          {/* LEFT: Text */}
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
            style={{ flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'flex-start' }}
          >
            <Typography variant="h2" sx={{ fontSize: { xs: '32px', md: '36px' }, fontWeight: 600, color: '#141414', mb: 3, textAlign: { xs: 'center', md: 'left' } }}>
              Lifetime support assistance and software maintenance
            </Typography>
            <Typography sx={{ fontSize: { xs: '16px', md: '18px' }, color: '#7B7B7B', mb: 4, lineHeight: 1.7, textAlign: { xs: 'center', md: 'left' } }}>
              All software owners get support assistance and software maintenance. Support will answer questions on how it works, software features and functionalities. We will maintain communication not only with the IT team, but also with Sales, Accountants, AML Officers, etc. Software maintenance includes not only bug fixing, but also new integrations with the partners, self and joint developed professional software features.
            </Typography>
          </motion.div>

          {/* RIGHT: Image and Social Media Icons */}
          <motion.div
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: 0.2 }}
            style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'flex-start' }}
          >
            <Box component="img" src={teamInnovation} alt="Team" sx={{ width: '100%', maxWidth: '500px', height: 'auto', borderRadius: '12px', mb: 3 }} />
            <Typography sx={{ fontSize: { xs: '14px', md: '16px' }, color: '#7B7B7B', mb: 3, textAlign: 'center' }}>
              We use Telegram or WhatsApp for convenient communication
            </Typography>
            <Box sx={{ display: 'flex', gap: 3, justifyContent: 'center' }}>
              <Box component="img" src={telegramLogo} alt="Telegram" sx={{ width: 112, height: 75, objectFit: 'cover' }} />
              <Box component="img" src={whatsappLogo} alt="WhatsApp" sx={{ width: 112, height: 75, objectFit: 'cover' }} />
            </Box>
          </motion.div>
        </Box>
      </Container>
    </Box>
  );
};

export default SupportSection;
